import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import Url from 'url-parse';

import {
  ThemedVideoButton,
  ThemedVideoOverlay,
} from '../themes';


class VideoOverlay extends Component {
  render() {
    const { url, root } = this.props;
    const videoUrl = new Url(url, true);
    const videoId = videoUrl.query.v;
    let videoSrc;

    if (videoId) {
      videoSrc = `https://www.youtube.com/embed/${ videoId }?autoplay=0&rel=0&modestbranding=1`;
    } else {
      videoSrc = url;
    }

    return (
      <ThemedVideoOverlay root={ root } videoSrc={ videoSrc } />
    );
  }
}

class VideoButton extends Component {
  constructor(props) {
    super(props);
    this.showVideo = this.showVideo.bind(this);
  }

  showVideo() {
    const { url } = this.props;

    history.pushState('', document.title, `${ window.location.pathname }#watch`);

    const el = document.querySelector('[data-overlay]');
    const root = createRoot(el);
    root.render(
      <VideoOverlay root={ root } url={ url } />
    );
  }

  render() {
    const { buttonContent, buttonClass, buttonIcon } = this.props;
    return (
      <ThemedVideoButton
        buttonContent={ buttonContent }
        buttonClass={ buttonClass }
        buttonIcon={ buttonIcon }
        onClick={ this.showVideo }
      />
    );
  }
}

function init() {
  document.querySelectorAll('[data-video]').forEach(el => {
    const url = el.getAttribute('data-video-url');
    const buttonContent = el.getAttribute('data-button-content');
    const buttonClass = el.getAttribute('data-button-class');
    const buttonIcon = el.getAttribute('data-button-icon');
    const root = createRoot(el);
    root.render(
      <VideoButton
        url={ url }
        buttonContent={ buttonContent }
        buttonClass={ buttonClass }
        buttonIcon={ buttonIcon }
      />
    );
  });

  const shouldWatch = window.location.hash === '#watch';
  if (shouldWatch) {
    const el = document.querySelector('[data-video]');
    const url = el.getAttribute('data-video-url');
    const overlayEl = document.querySelector('[data-overlay]');
    const overlayRoot = createRoot(overlayEl);
    overlayRoot.render(
      <VideoOverlay root={ overlayRoot } url={ url } />
    );
  }
}

export default { init };
